/**
 * 健康管理 - 权限检查工具函数
 * 优先调用 /api/health/check（轻量），通过即有权限；
 * 失败时回退：localStorage 中 user.isAdmin=true 也视为有权限
 */
import { checkAccess } from '../services/healthApi';

/**
 * 检查用户是否有健康管理权限
 */
export const hasHealthPermission = async () => {
  const token = localStorage.getItem('token');
  if (!token) return false;

  try {
    const res = await checkAccess();
    if (res?.success && res?.data?.allowed) return true;
  } catch (_e) {
    /* API 失败时尝试 localStorage 回退 */
  }

  try {
    const userStr = localStorage.getItem('user');
    if (userStr) {
      const user = JSON.parse(userStr);
      if (user.isAdmin === true || user.isAdmin === 'true') return true;
    }
  } catch (_e) {}

  return false;
};
